<template>
  <div class="headerComponent">
    <nav class="headerComponent__container">
      <a @click="goFirstSpaOrUrlConfigured()" class="headerComponent__brandLogo"  tabindex="40" data-toggle="modal" data-target="#modal-modify_search">
        <img v-if="$route.name !== 'widget-booking'" :src="getImageLogo()" width="auto" height="20" alt="">
      </a>
      <div v-if="!onlyLanguage"
           class="steps"
           :class="{
            'secondStep': isRouteActive(2),
            'thirdStep': isRouteActive(3),
            'lastStep': isRouteActive(4)
           }"
      >
        <div class="steps__step --active"
             :class="{
               '': isRouteActive(0)
             }"
        >
          <span class="steps__dot"></span>
          <span class="steps__label" v-if="readyI18n">{{ $t('stepper_flights') }}</span>
        </div>
        <div class="steps__step"
             :class="{
               '--active': isRouteActive(2)
             }"
        >
          <span class="steps__dot"></span>
          <span class="steps__label" v-if="readyI18n">{{ $t('stepper_passenger') }}</span>
        </div>
        <div v-if="haveExtraServices" class="steps__step"
             :class="{
               '--active': isRouteActive(3)
             }"
        >
          <span class="steps__dot"></span>
          <span class="steps__label" v-if="readyI18n">{{ $t('stepper_extras') }}</span>
        </div>
        <div class="steps__step"
             :class="{
               '--active': isRouteActive(4)
             }"
        >
          <span class="steps__dot"></span>
          <span class="steps__label" v-if="readyI18n">{{ $t('stepper_pay') }}</span>
        </div>
      </div>
      <div class="d-flex">
        <!-- currency switcher -->
        <currencySwitcher v-if="showCurrencyComponent()"/>
        <!-- lang switcher -->
        <langSwitcher @readyLangSwitcher="setReadyLangSwitcher"/>
        <!-- user account -->
        <!-- <userAccount/> -->
        <div id="userAccount"></div>
        <!-- summary -->
        <div v-if="!hideSummaryToggle"
           class="summaryToggle"
           @click="summaryToggle"
        >
          <i class="fas fa-bars fa-lg"></i>
          <i class="fas fa-times fa-lg"></i>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  import langSwitcher from './LangSwitcher'
  import currencySwitcher from './CurrencySwitcher'
  import userAccount from './UserAccount'
  import { get } from 'lodash'

  export default {
    name: 'Header',
    components: {
      langSwitcher,
      userAccount,
      currencySwitcher
    },
    props: {
      onlyLanguage: {
        type: Boolean,
        default: () => false
      },
      hideSummaryToggle: {
        type: Boolean,
        default: () => false
      },
      showCurrencySelector: {
        type: Boolean,
        default: () => false
      },
      onpopstateEnabled: {
        type: Boolean,
        default: () => true
      },
    },
    data () {
      return {
        stepsValues: {
          'availability': 1,
          'passengers': 2,
          'residents': 2,
          'serviceHub': 3,
          'purchase': 4,
          'end-of-flow': 4
        },
        readyI18n: false,
        haveExtraServices: false
      }
    },
    beforeMount() {
      var flow = this.$store.state.systemStore.flow
      for (var spa in flow) {
        if (flow[spa].url === '/extraservices/') {
          this.haveExtraServices = true
          var rootElement = document.documentElement
          rootElement.style.setProperty('--widthExtra', '340px')
          rootElement.style.setProperty('--widthExtraStep', '460px')
          rootElement.style.setProperty('--widthScalex', '0.33')
        }
      }
    },
    methods: {
      isRouteActive: function (stepValue) {
        return this.stepsValues[this.$route.name] >= stepValue
      },
      showCurrencyComponent: function () {
        return this.showCurrencySelector && get(this.$store.getters, 'getCountrySetting.list', []).length > 1
      },
      summaryToggle () {
        this.$store.commit('summaryBehaviorHandler', { state: 'relative' })
      },
      goFirstSpaOrUrlConfigured (){
        if (!this.$store.getters.getLogoUrlRedirect){
          this.$store.dispatch('goFirstSpa')
        } else {
          window.location.href = this.$store.getters.getLogoUrlRedirect
        }
      },
      getImageLogo: function () {
        let url = this.$store.getters.getConfigUrls.staticUrl.split('/')
        url[url.length - 1] = 'header.jpg'
        return url.join('/')
      },
      setReadyLangSwitcher: function () {
        this.readyI18n = true
        this.$emit('readyLangSwitcher')
      }
    }
  }
</script>

<style lang="sass">
.headerComponent__container
  z-index: 9999
  min-height: 3.5rem
  background-color: var(--color-nav)
  display: flex
  flex-direction: row
  align-items: center
  position: fixed
  top: 0
  left: 0
  width: 100%
  box-shadow: var(--z-1)
  flex-wrap: wrap
  justify-content: space-between
  padding: 0
  color: var(--color-onNav)
.headerComponent__brandLogo
  margin-left: 1rem
  height: 1.75rem
  outline: none
  cursor: pointer
  img
    height: 100%
.summaryToggle
  display: block
  background-color: transparent
  height: 3.5rem
  width: 3.5rem
  margin: 0
  position: relative
  cursor: pointer
  transition: background-color 0.2s ease
  .--summary-active &
    background-color: var(--color-overlay-10)
    .fa-bars
      transform: rotate(90deg)
      opacity: 0
    .fa-times
      transform: rotate(0deg)
      opacity: 1
  .fa-bars, .fa-times
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    display: flex
    align-items: center
    justify-content: center
    margin: auto
    transition: transform 0.3s ease, opacity 0.2s ease
  .fa-times
    transform: rotate(-90deg)
    opacity: 0
/////////////////////////////////
// steps
\:root
  --steps__dot-border-color: var(--color-onNav)
  --steps__dot-background-color: var(--color-nav)
  --steps__dot-active-background-color: var(--color-primary)
  --steps__dot-active-border-color: var(--color-nav)
  --steps__dot-done-border-color: var(--color-nav)
  --steps__dot-done-background-color: var(--color-success)
  --steps__bar-track-fill-color: var(--color-success)
  --steps__bar-track-color: var(--color-overlay-10)
  --steps__label-color: var(--color-onNav)
  --steps__label-active-color: var(--color-primary)
  --steps__label-done-color: var(--color-success)
.steps
  display: flex
  width: var(--widthExtraStep, 410px)
  flex-direction: row
  text-align: center
  position: relative
  padding-top: 4px
  &:after, &:before
    content: ''
    display: block
    height: 2px
    width: var(--widthExtra, 275px)
    position: absolute
    left: 0
    right: 0
    margin: auto
    top: 8px
    background-color: var(--steps__bar-track-color)
    transition: ease .3s
    transform-origin: left
    z-index: -1
  &:before
    transform: scaleX(0)
    background-color: var(--steps__bar-track-fill-color)
    opacity: 1
    z-index: 0
  &.secondStep
    &:before
      transform: scaleX(var(--widthScalex, 0.5))
    .steps__step:first-child
      .steps__dot
        background-color: var(--steps__dot-done-background-color)
        box-shadow: inset 0 0 0 1px var(--steps__dot-done-border-color)
      .steps__label
        color: var(--steps__label-done-color)
  &.thirdStep
    &:before
      transform: scaleX(0.66)
    .steps__step:first-child, .steps__step:nth-child(2)
      .steps__dot
        background-color: var(--steps__dot-done-background-color)
        box-shadow: inset 0 0 0 1px var(--steps__dot-done-border-color)
      .steps__label
        color: var(--steps__label-done-color)
  &.lastStep
    &:before
      transform: scaleX(1)
    .steps__step:first-child, .steps__step:nth-child(2), .steps__step:nth-child(3)
      .steps__dot
        background-color: var(--steps__dot-done-background-color) !important
        box-shadow: inset 0 0 0 1px var(--steps__dot-done-border-color) !important
      .steps__label
        color: var(--steps__label-done-color) !important
  &__step
    width: 100%
    &.--active
      opacity: 1
      .steps__dot
        background-color: var(--steps__dot-active-background-color)
        box-shadow: inset 0 0 0 1px var(--steps__dot-border-color), 0 0 0 2px var(--color-nav)
      .steps__label
        opacity: 1
        color: var(--steps__label-active-color)
  &__dot
    margin: 0 auto
    display: block
    background-color: var(--steps__dot-background-color)
    box-shadow: inset 0 0 0 1px var(--steps__dot-border-color)
    height: 10px
    width: 10px
    border-radius: 50%
    color: var(--color-onNav)
    position: relative
    transition: .1s
    transition-delay: .1s
  &__label
    text-transform: uppercase
    display: block
    font-size: var(--font-size-xs)
    font-weight: bolder
    color: var(--steps__label-color)
    margin-top: 5px
    opacity: .5
/////////////////////////////////
// fin steps

@media (max-width: 768px)
  .steps
    display: none !important
</style>
